import { render } from "./GalleryCopy.vue?vue&type=template&id=711ca85c&scoped=true"
import script from "./GalleryCopy.vue?vue&type=script&lang=js"
export * from "./GalleryCopy.vue?vue&type=script&lang=js"

import "./GalleryCopy.vue?vue&type=style&index=0&id=711ca85c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711ca85c"]])

export default __exports__